// extracted by mini-css-extract-plugin
export default {"group":"MessageGroup_group__inDO3","group-incoming":"MessageGroup_group-incoming__qupxV","group-outgoing":"MessageGroup_group-outgoing__WBsmD"};